import { BsModalService } from 'ngx-bootstrap';
import { RespondConfirmation } from '../objects/DialogObject';
import { Observable } from 'rxjs';
import { MessagePopupComponent } from '../message-popup/message-popup.component';
import * as i0 from "@angular/core";
import * as i1 from "ngx-bootstrap/modal";
import * as i2 from "../objects/DialogObject";
var MessagePopupService = /** @class */ (function () {
    function MessagePopupService(bsModalService, respondConfirmation) {
        this.bsModalService = bsModalService;
        this.respondConfirmation = respondConfirmation;
    }
    MessagePopupService.prototype.popMessage = function (title, message, options) {
        var initialState = {
            title: title,
            message: message,
            options: options,
            answer: ""
        };
        document.body.classList.add('modal-message');
        if (this.bsModalService.getModalsCount() > 0) {
            document.querySelectorAll('.modal.fade').item(this.bsModalService.getModalsCount() - 1).classList.remove('show');
        }
        this.bsModalRef = this.bsModalService.show(MessagePopupComponent, { class: "modal-dialog-centered modal-message", ignoreBackdropClick: true, initialState: initialState });
        return new Observable(this.getConfirmSubscriber());
    };
    MessagePopupService.prototype.getConfirmSubscriber = function () {
        var _this = this;
        return function (observer) {
            var subscription = _this.bsModalService.onHidden.subscribe(function (reason) {
                document.body.classList.remove('modal-message');
                if (document.querySelectorAll('.modal-backdrop').item(0)) {
                    document.querySelectorAll('.modal-backdrop').item(0).classList.remove('layer');
                }
                if (_this.bsModalService.getModalsCount() > 0) {
                    document.querySelectorAll('.modal.fade').item(_this.bsModalService.getModalsCount() - 1).classList.add('show');
                }
                _this.respondConfirmation.answer = _this.bsModalRef.content.answer;
                observer.next(_this.respondConfirmation);
                observer.complete();
            });
            return {
                unsubscribe: function () {
                    subscription.unsubscribe();
                }
            };
        };
    };
    MessagePopupService.ngInjectableDef = i0.defineInjectable({ factory: function MessagePopupService_Factory() { return new MessagePopupService(i0.inject(i1.BsModalService), i0.inject(i2.RespondConfirmation)); }, token: MessagePopupService, providedIn: "root" });
    return MessagePopupService;
}());
export { MessagePopupService };
